import * as React from 'react';
import b_ from 'b_';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useTrack } from 'shared/utils/track';
import { IdeaTopCard } from 'components/IdeaTopCard';
import { Breadcrumb } from 'components/Breadcrumb';
import NotFound from 'shared/components/NotFound';
import { lifecycle } from './actions';
import { SubmitSection } from './components/SubmitSection';
import { useIdeaLanding } from './hooks';

import './index.scss';

export interface Props {
  id: number;
}

const b = b_.with('idea-landing');

export const IdeaLanding: React.FC<Props> = ({ id }) => {
  const { t } = useTranslation();

  const { idea, loading, isExpired, activeBuyOrderId } = useIdeaLanding(id);

  useTrack(lifecycle, { id });

  if (loading) {
    return null;
  }

  if (!idea) {
    return <NotFound />;
  }

  return (
    <div className={b()} data-testid="idea-landing">
      <Helmet>
        <title>{`${t('Invest in {{name}}', { name: idea.name })} | United Traders`}</title>
        <meta name="description" content={idea.description || ''} />
      </Helmet>
      <Breadcrumb />
      <div className={b('top-card')}>
        <IdeaTopCard idea={idea} isIdeaLandingCard={true} chartBaseLine />
      </div>
      <SubmitSection idea={idea} isExpired={isExpired} activeOrderId={activeBuyOrderId} />

      <div dangerouslySetInnerHTML={{ __html: idea.fullDescription || '' }} />

      <SubmitSection idea={idea} isExpired={isExpired} activeOrderId={activeBuyOrderId} />
    </div>
  );
};
